import axios from "axios";
import { getToken } from "../../auth/authService"; // make sure this path is correct

// Create an axios instance with base URL and authorization header
const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { Authorization: `Bearer ${getToken()}` },
});

// ===============================
// Subscription Plans APIs
// ===============================

// Fetch all active subscription plans
export const fetchActivePlans = () => api.get("/subscription-plans/active");

// Purchase a subscription plan
export const purchasePlan = (userId, planId) =>
  api.post("/user-subscriptions/purchase", null, { params: { userId, planId } });

// Get active subscription for a user
export const getActiveSubscription = (userId) =>
  api.get(`/user-subscriptions/active/${userId}`);

// Get active subscription summary for a user
export const getActiveSubscriptionSummary = (userId) =>
  api.get(`/user-subscriptions/active-summary/${userId}`);

// Get all subscriptions (history) for a user
export const getAllSubscriptions = (userId) =>
  api.get(`/user-subscriptions/all/${userId}`);

// Get all available plans for a user
export const getAvailablePlans = (userId) =>
  api.get(`/user-subscriptions/available/${userId}`);
